import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import AuthorizedRoute from 'routes/AuthorizedRoute';

import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';

import { URL as DASHBOARD_URL } from 'pages/dashboard/helper';

import UserSegmentHome from './userSegmentHome';
import { URL, COMPONENT, USER_SEGMENT_RESOURCES, GET_ACTION } from './helper';

const UserSegmentInfo: React.FC<{}> = () => {
	return (
		<>
			<Switch>
				<AuthorizedRoute
					exact
					configPageName={PAGE_NAMES.dashboard}
					path={DASHBOARD_URL[DASHBOARD_RESOURCES.userSegment]}
					component={UserSegmentHome}
				/>
				{_map(_values(USER_SEGMENT_RESOURCES), (subEntity: string) => (
					<AuthorizedRoute
						key={subEntity}
						configPageName={PAGE_NAMES.dashboard}
						entity={DASHBOARD_RESOURCES.userSegment}
						actions={[GET_ACTION[subEntity]]}
						path={URL[subEntity]}
						component={COMPONENT[subEntity]}
					/>
				))}
				<Redirect to={DASHBOARD_URL[DASHBOARD_RESOURCES.userSegment]} />
			</Switch>
		</>
	);
};

export default UserSegmentInfo;
